var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-button',_vm._g(_vm._b({class:_vm.classes,attrs:{"disabled":_vm.loadingOrDisabled}},'core-button',_vm.$attrs,false),_vm.$listeners),[_c('span',{style:(_vm.getStyle)},[_vm._t("default")],2),(_vm.loading)?_c('svg-loading',{staticClass:"loading-button-spinner"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }